// src/config.js
export const DEV_MODE = process.env.REACT_APP_DEV_MODE === "true";
export const AUTH_BYPASS = process.env.REACT_APP_AUTH_BYPASS === "true";
export const E2E_AUTH_MODE = process.env.REACT_APP_E2E_AUTH_MODE === "true";